import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactPlayer from 'react-player';

import { api, useAPIContext } from '../../../../api/context';
import toast from '../../../../utils/toast';
import { Title } from '../../../../utils/title';
import Icon from '../../../../components/Icon';
import Layout from '../Layout';
import styles from './Media.module.scss';

const Media = () => {

  const [ loading, setLoading ] = useState(true);
  const [ media, setMedia ] = useState(null);

  const input = useRef();

  const { token } = useAPIContext();

  useEffect(() => {

    setLoading(true);

    api(token).v1.profile.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          setMedia(res.body.data.media);
        }
      })
      .catch(err => {
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  const submit = () => {

    const file = input.current.files[0];
    if (!file) {
      toast.show(toast.KIND.WARNING, 'Please select a file.');
      return;
    }

    setLoading(true);

    const data = new FormData();
    data.append('media', file, file.name);

    api(token).v1.profile.update(data)
      .then(res => {
        setLoading(false);

        if (res.status === 200) {
          setMedia(res.body.data.media);
          input.current.value = '';
          toast.show(toast.KIND.SUCCESS, 'Profile picture saved.');
        }

        if (res.status === 400) {
          toast.show(toast.KIND.ERROR, res.body);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  };

  return (
    <>
      <Title value='Picture - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Change Picture</h1>
            </div>

            <div className={styles.media}>

              <div className={styles.current}>
                {
                  media && media.kind === 'I' && (
                    <LazyLoadImage
                      alt='profile image'
                      src={media.url}
                    />
                  )
                }

                {
                  media && media.kind === 'V' && (
                    <ReactPlayer
                      alt='profile video'
                      src={media.url}
                      autoPlay={true}
                      loop={true}
                    />
                  )
                }
              </div>

              <div className={styles.upload}>
                <input
                  ref={input}
                  type='file'
                  aria-label='file upload'
                  disabled={loading}
                />
              </div>

              <div className={styles.action}>
                <button
                  onClick={() => submit()}
                  disabled={loading}>

                  Save

                </button>
              </div>

            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Media;